import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { REHYDRATE } from "redux-persist";
import Datastore from "../../communication/Datastore";

import store, { IAppState } from "../../state/Store";

import ProductSubscription from "../../types/core/ProductSubscription";

// Define the type for our state store entry
type ProductSubscriptionState = {
    productSubscriptions: ProductSubscription[];
    status: string;
    error: string;
};

// Define the initial state for our state store entry
const initialState: ProductSubscriptionState = {
    productSubscriptions: [],
    status: "idle",
    error: null,
};

// Create a slice to hold all our reducers
const productSubscriptionSlice = createSlice({
    name: "productSubscription",
    initialState: initialState,
    reducers: {},
    extraReducers(builder) {
        builder
            .addCase(REHYDRATE, (_, rawData: any) => {
                if (rawData?.key !== "tts") return undefined;
                return {
                    productSubscriptions:
                        rawData?.payload?.productSubscription
                            ?.productSubscriptions ?? [],
                    status:
                        !rawData?.payload?.productSubscription
                            ?.productSubscriptions ||
                        !rawData?.payload?.productSubscription
                            ?.productSubscriptions?.length
                            ? "idle"
                            : rawData?.payload?.productSubscription?.status,
                    error: null,
                };
            })
            .addCase(fetchProductSubscriptions.pending, (state, action) => {
                state.status = "loading";
            })
            .addCase(fetchProductSubscriptions.fulfilled, (state, action) => {
                state.status = "succeeded";
                // Add any fetched posts to the array
                state.productSubscriptions = action.payload;
            })
            .addCase(fetchProductSubscriptions.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.error.message;
            });
    },
});

// This is a thunk, they are used to load the state
export const fetchProductSubscriptions = createAsyncThunk(
    "clientSystem/fetchProductSubscriptions",
    async () => {
        return await Datastore.getType<ProductSubscription[]>(
            "api/ProductSubscriptions",
        );
    },
);

// This is a thunk, they are used to load the state
export const fetchLicenceFile = async function() {
    return await Datastore.getType<string>("api/ProductSubscriptions/Licence");
};

export const initialiseProductSubscriptions = createAsyncThunk<
    ProductSubscription[]
>("clientSystem/initialiseProductSubscriptions", async (_, thunkAPI) => {
    const { productSubscription } = store.getState().db;

    if (productSubscription.status === "idle")
        await thunkAPI.dispatch(fetchProductSubscriptions());

    return store.getState().db.productSubscription
        .productSubscriptions;
});

// We have to export the reducer as this is added to the state store
export default productSubscriptionSlice.reducer;
